import React from 'react';
import { useTranslation } from '@/i18n';
import { acquireCluster } from '@/utils';

const SubmitTitle: React.FC = () => {
  const { t } = useTranslation('i18n_ecom_shop_email');
  const isTTP = acquireCluster() === 'ttp';
  return <>{isTTP ? t('submit_button_on_email_popup_window', 'Submit') : t('seller_center_continue_common', 'Next')}</>;
};

export default SubmitTitle;
